export default __webpack_public_path__ + "static/media/forgetmenot-logo.a3252707.png";